import { useNavigate } from "react-router-dom";
import styles from '../cssModules/index.module.css';
import { Dropdown, Form } from 'react-bootstrap';


export default function ShawlUpdate({ id, prod, setProd, loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;
    let jToken = localStorage.getItem('token');
    // const { prodId } = useParams();
    // const [prod, setProd] = useState({});
    const navigate = useNavigate();

    const fabric = ['Cotton', 'Denim', 'Fleece', 'Rayol', 'Chiffon', 'Wool', 'Art silk', 'Corduroy', 'Crepe', 'Down', 'Faux Fur', 'Fur', 'Georgette', 'Lenin', 'Modal',
        'Rayon', 'Satin', 'Silk', 'Synthetic', 'Velvet', 'Net', 'Rubber'
    ];

    const color = ['red', 'green', 'blue', 'grey', 'white', 'black', 'brown', 'pink', 'orange', 'yellow', 'purple', 'gold', 'silver',
        'turquoise', 'whitesmoke'];

    const size = ['S', 'M', 'L', 'XS', 'X', 'XL', '2XL', '3XL', '4XS', '5XL', '6XL', '7XL', '8XL', 'Free'];

    const userSegment = ['Men', 'Women'];

    const weightCat = ['Category 1 (upto 500 gm)', 'Category 2 (between 500 gm to 1 kg)', 'Category 3 (between 1 to 2 kg)']

    const stock = ['In stock', 'Out of stock']

    function changeWeightCat(value) {
        switch (true) {
            case (value === 'Category 1 (upto 500 gm)'):
                return 1;
            case (value === 'Category 2 (between 500 gm to 1 kg)'):
                return 2;
            default:
                return 3;
        }
    }

    function changeWeightCatReverse(value) {
        switch (true) {
            case (Number(value) === 1):
                return 'Category 1 (upto 500 gm)';
            case ((Number(value)) === 2):
                return 'Category 2 (between 500 gm to 1 kg)';
            default:
                return 'Category 3 (between 1 to 2 kg)';
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${apiURL}/change/${id}`, {
                method: 'POST',
                headers: {
                    'Content-type': 'Application/json',
                    'Authorization': `Bearer ${jToken}`
                },
                body: JSON.stringify(prod),
                credentials: 'include'
            })
            if (response.status === 200) {
                alert('Updated the product!');
                navigate('/manage');
            } else {
                await loginStatus();
                navigate('/login');
            }
        } catch (error) {
            console.log(error.message);
        }
    }

    const toggleSelection = (size, stock) => {
        try {
            let newArr;
            // prod = { 'additionSize': { 'XL': 20, 'xxl': 24, 'L': 10 } }
            if (stock) {
                // This will handle the situatioin when user already has size previously or not
                newArr = { ...prod['additionsize'], [size]: Number(stock) };
                setProd(prev => {
                    return { ...prev, "additionsize": newArr }
                });
            } else {
                if (Object.keys(prod['additionsize']).includes(size)) {
                    newArr = Object.fromEntries(
                        Object.entries(prod['additionsize']).filter(([key]) => {
                            return key !== size;
                        })
                    )
                    setProd(prev => {
                        return { ...prev, "additionsize": newArr }
                    })
                } else {
                    newArr = { ...prod["additionsize"], [size]: null }
                    setProd(prev => {
                        return { ...prev, "additionsize": newArr }
                    })
                }
            }
        } catch (error) {
            console.log(error.message);
        }
    };

    return (
        <>
            {prod && (
                <div className={`${styles.sellerUpdate}`}>
                    <form id='uploadForm' onSubmit={handleSubmit}>
                        <div className={`${styles.updateIndividualMainDiv}`}>
                            <img src={`${apiURL}/images/${prod.photo1}`} alt='img' className={`${styles.updateIndividualImage}`} />
                            <div className={`${styles.sellerUpdateDiv}`}>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='fabric'>
                                        Fabric
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='fabric' name='fabric' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.fabric} selected hidden>{prod.fabric}</option>
                                        {fabric.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                {/* <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='size'>
                                        Size
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='size' name='size' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.size} selected hidden>{prod.size}</option>
                                        {size.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div> */}

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='userSegment'>
                                        User segment
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='userSegment' name='userSegment' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.userSegment} selected hidden>{prod.userSegment}</option>
                                        {userSegment.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='name'>
                                        Name
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='name' defaultValue={prod.name} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true} type='text' placeholder="Name of the product" name='name' />
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='color'>
                                        Color
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='color' name='color' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.color} selected hidden>{prod.color}</option>
                                        {color.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='price'>
                                        Price
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='price' defaultValue={prod.oldPrice} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: Number(e.target.value) }) })} required={true} type='number' placeholder="price" name='oldPrice' />
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='dPrice'>
                                        Discount Price
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='dPrice' defaultValue={prod.currentPrice} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: Number(e.target.value) }) })} required={true} type='number' placeholder="This price will be highlighted" name='currentPrice' />
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='weightCat'>
                                        Weight category (Courier ready)
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='weightCat' name='weightCat' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.weightCat} selected hidden>{changeWeightCatReverse(prod.weightCat)}</option>
                                        {weightCat.map(item => {
                                            return (
                                                <>
                                                    <option value={changeWeightCat(item)}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>


                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='stock'>
                                        Stock
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='stock' name='active' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.active} selected hidden>{prod.active}</option>
                                        {stock.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>


                                {/* <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='stock'>
                                        In stock
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='stock' defaultValue={prod.stock} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: Number(e.target.value) }) })} required={true} type='number' placeholder="Available stock" name='stock' />
                                </div> */}

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="primary">Sizes</Dropdown.Toggle>
                                        <Dropdown.Menu
                                        // bsPrefix={`form-control, ${styles.dropdownMenu}`}
                                        >
                                            {size.map((option, idx) => (
                                                <>
                                                    <div className={`${styles.formControlDiv}`}>
                                                        <div style={{ flexBasis: '50%', fontSize: '13px' }}>
                                                            <Form.Check
                                                                key={idx}
                                                                type="checkbox"
                                                                label={option}
                                                                checked={Object.keys(prod['additionsize']).includes(option)}
                                                                onChange={() => toggleSelection(option, null, 'additionsize')}
                                                                className="px-3"
                                                            />
                                                        </div>
                                                        <div style={{ flexBasis: '50%' }}>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Stock'
                                                                key={idx}
                                                                value={prod['additionsize'][option] ? prod['additionsize'][option] : null}
                                                                onChange={(e) => toggleSelection(option, e.target.value, 'additionsize')}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='sku'>
                                        Stock keeping unit
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='sku' defaultValue={prod.sku}
                                        onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true} type='text' placeholder="SKU" name='sku' />
                                </div>

                            </div>
                            <input type="submit" value='UPDATE' className={`${styles.sellerUpdateButton}`} />
                        </div>
                    </form>
                </div>
            )}
        </>
    )
}